export const getURLParameters = url => {
  if (url.indexOf('?') === -1) return {}
  return url.match(/([^?=&]+)(=([^&]*))/g).reduce((a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {})
}

// 配置请求
const prefixUrl = "https://static.yiliit.com";

export async function fetchConfig() {
  try {
    const response = await fetch(`${prefixUrl}/official_web/config.js`);
    if (!response.ok) {
      throw new Error("请求失败");
    }
    const text = await response.text();
    // 去除 export default 并使用 new Function 解析，以避免 Webpack 打包远程 import 报错
    const jsText = text.replace(/export\s+default/, 'return');
    const data = new Function(jsText)();

    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}